import instance from "./dsdInstance";
import {API_URL} from "../config/api";

export default class AiPresetService {

    static presetPublish = async () => {
        try {
            const res = await instance.post(API_URL.AI_PRESET + '/publish');
            return res.data.data.result;
        } catch (e) {
            console.error(e);
        }
    }
    static deletePreset = async id => {
        try {
            return  await instance.delete(API_URL.AI_PRESET + '/' + id);
        } catch (e) {
            console.error(e);
        }
    }
    static createPreset = async params => {
        try {
            return  await instance.post(API_URL.AI_PRESET, params);
        } catch (e) {
            console.error(e);
        }
    }
    static editPreset = async params => {
        try {
            return  await instance.put(API_URL.AI_PRESET, params);
        } catch (e) {
            console.error(e);
        }
    }
    static getAllPresets = async() => {
       try {
        const res =  await instance.get(API_URL.AI_PRESET);
        return res.data.data.result;
       } catch (e) {
           console.error(e);
       }
    }
}